import { AuthProvider } from '../contexts/AuthContext';
import configureAmplify from 'config/amplify-configuration';
import { RouterProvider } from 'react-router';
import router from './routes/router';
import { UserProvider } from '../contexts/UserContext';
import ContactWidget from 'components/contact/ContactWidget';
import { useSyncExternalStore } from 'react';
import { matchPath } from 'react-router-dom';
import { ROUTES } from 'config/route-configuration';

configureAmplify();

const useCurrentPathname = () =>
  useSyncExternalStore(
    router.subscribe,
    () => router.state.location.pathname,
    () => router.state.location.pathname
  );

const App = () => {
  const pathname = useCurrentPathname();
  const hideContactWidget = Boolean(matchPath(ROUTES.PUBLIC_PROPOSAL, pathname));

  return (
    <AuthProvider>
      <UserProvider>
        <RouterProvider router={router} />
        {!hideContactWidget && <ContactWidget />}
      </UserProvider>
    </AuthProvider>
  );
};

export default App;
